import { render, staticRenderFns } from "./devicesDashboardExerciseForm.vue?vue&type=template&id=fda68d42&scoped=true&xmlns=true"
import script from "./devicesDashboardExerciseForm.vue?vue&type=script&lang=js"
export * from "./devicesDashboardExerciseForm.vue?vue&type=script&lang=js"
import style0 from "./devicesDashboardExerciseForm.vue?vue&type=style&index=0&id=fda68d42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda68d42",
  null
  
)

export default component.exports